import React from "react";
import { GRAY, GRAY_DARK, GRAY_DARKEST, GRAY_LIGHT } from "../../constants";
import { makeStyles } from "@material-ui/core/styles";
import { InputAdornment, FormControl, TextField } from "@material-ui/core";
import PropTypes from "prop-types";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles(() => ({
  fullWidthContainer: {
    display: "flex",
    flexWrap: "wrap",
    width: "100% !important"
  },
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    width: "100% !important",
    backgroundColor: GRAY_DARKEST,
    borderRadius: 5,
    "&:hover $notchedOutline": {
      borderColor: GRAY_DARK
    },
    "&:hover $searchIcon": {
      color: GRAY_LIGHT
    }
  },
  notchedOutline: {
    borderColor: GRAY_DARKEST
  },
  searchIcon: {
    color: GRAY
  }
}));

export default function BasicSearchField(props) {
  const classes = useStyles();
  const { fullWidth, label, handleKeyPress } = props;
  return (
    <FormControl
      className={fullWidth ? classes.fullWidthContainer : classes.container}
    >
      <TextField
        id={`outlined-basic-${label}`}
        className={classes.textField}
        label={label}
        variant="outlined"
        fullWidth
        margin="none"
        value={props.searchText || ""}
        onChange={props.handleFieldChange}
        InputProps={{
          endAdornment: (
            <InputAdornment>
              <SearchIcon className={classes.searchIcon} />
            </InputAdornment>
          ),
          classes: {
            root: classes.textField,
            input: classes.textField,
            notchedOutline: classes.notchedOutline,
            focused: classes.textField
          }
        }}
        inputProps={{
          fieldname: props.fieldname
        }}
        onKeyDown={handleKeyPress}
      />
    </FormControl>
  );
}

BasicSearchField.propTypes = {
  fieldname: PropTypes.string,
  label: PropTypes.string,
  searchText: PropTypes.string,
  handleFieldChange: PropTypes.func,
  handleKeyPress: PropTypes.func
};
